import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold mx-7 my-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.store) + "の応募期間は", 1),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("span", null, _toDisplayString(_ctx.formattedBegin) + " ～ " + _toDisplayString(_ctx.formattedEnd) + "です。", 1)
  ]))
}